export default {
	title: 'dark',

	colors: {
		primary: '#1d3557',
		secondary: '#457b9d',
		background: '#333',
		text: '#FFF',
	},
};
